<template>
  <file-picker @picked="picked" accept="image">
    <slot slot="trigger" name="trigger"></slot>
  </file-picker>
</template>

<script>
import FilePicker from "./FilePicker";
import UploadBookImageModal from "./UploadBookImageModal";

export default {
  components: {
    FilePicker
  },

  props: {
    endpoint: {
      type: String,
      required: true
    },

    fileFieldName: {
      type: String,
      default: "file"
    },

    additional: {
      type: Object
    },

    croppable: {
      type: Boolean,
      default: false
    },

    croppie: {
      type: Object,
      default: null
    }
  },

  methods: {
    picked(file) {
      this.$buefy.modal.open({
        component: UploadBookImageModal,
        props: {
          file,
          config: this,
          whenUploaded: image => this.$emit("uploaded", image)
        }
      });
    }
  }
};
</script>
